module.exports = __webpack_public_path__ + "img/icon-legalleria.6a70e24e.svg";